// extracted by mini-css-extract-plugin
export default {"section":"notFoundPage_section__nuj58","contentBox":"notFoundPage_contentBox__y-Sgp","description":"notFoundPage_description__8F94M","image":"notFoundPage_image__eiGOT"};